import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  // Still checking auth state
  if (user === undefined) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        Checking authentication…
      </div>
    );
  }

  // Not authenticated → redirect to 403
  if (!user) {
    return <Navigate to="/404" replace />;
  }

  // Authenticated → allow access
  return children;
};

export default ProtectedRoute;
